// Bilingual translations DE/EN for LionPerformance — Application-based (exclusive coaching)
export const translations = {
  de: {
    nav: {
      why: "Warum",
      coach: "Coach",
      services: "Leistungen",
      process: "Ablauf",
      faq: "FAQ",
      contact: "Bewerbung",
      cta: "Jetzt bewerben",
    },
    hero: {
      eyebrow: "Sportpsychologie · High Performance Coaching",
      title1: "Talent gewinnt Trainings.",
      title2: "",
      title3: "Der Kopf gewinnt Wettkämpfe.",
      subtitle:
        "Ein systematischer Prozess für Körper, Kopf und Psychologie — bis deine Leistung deinem Anspruch entspricht.",
      cta1: "Jetzt für Zusammenarbeit bewerben",
      cta2: "Mehr erfahren",
      scroll: "Scroll",
      trustbar: [
        "Kampfsport seit 1993",
        "Nationaltrainer WBC Muay Thai",
        "M.Sc. Sportpsychologie & -wissenschaften",
        "Aufnahme nur nach Bewerbung",
      ],
    },
    marquee: [
      "Wissenschaftlich fundiert",
      "Ausschließlich Privatkunden",
      "Weltweit online betreut",
      "Maximale Diskretion",
      "Messbare Leistungsentwicklung",
      "Nur nach Bewerbung",
    ],
    trust: {
      eyebrow: "Warum LionPerformance",
      title: "Betreuung, die Ergebnisse produziert.",
      subtitle:
        "Wir arbeiten wie du: kompromisslos, wissenschaftlich fundiert und maximal individuell. Aufnahme ausschließlich nach persönlicher Prüfung.",
      items: [
        {
          title: "Wissenschaftlich fundiert",
          desc: "Methoden aus Sportwissenschaft, Sportpsychologie und moderner Leistungsdiagnostik.",
        },
        {
          title: "Individuelle Betreuung",
          desc: "Keine Programme von der Stange – jede Zusammenarbeit ist maßgeschneidert.",
        },
        {
          title: "Maximale Diskretion",
          desc: "Alle Inhalte, Gespräche und Daten werden vertraulich behandelt.",
        },
        {
          title: "Flexibles Online Coaching",
          desc: "Weltweit betreut – über Zoom, Teams, Telefon oder persönlich.",
        },
        {
          title: "Messbare Entwicklung",
          desc: "Klare Kennzahlen, dokumentierter Fortschritt, transparente Wirkung.",
        },
        {
          title: "Aufnahme nur nach Bewerbung",
          desc: "Wir arbeiten bewusst mit einer sehr begrenzten Anzahl an Klienten.",
        },
      ],
    },
    coach: {
      eyebrow: "Über den Coach",
      title: "Erfahrung aus dem Spitzensport. Wissenschaft, die wirkt.",
      p1: "LionPerformance wird von einem erfahrenen Nationaltrainer der WBC Muay Thai Germany geführt.",
      p2: "Die Betreuung verbindet praktische Erfahrung aus dem Spitzensport mit wissenschaftlich fundierter Sportpsychologie und moderner Leistungsdiagnostik.",
      story:
        "Kampfsport seit 1993. Über 10 Jahre unter maximalem Druck als Beamter im Hochsicherheitsgefängnis — davon 2 in einer Spezialeinheit. Heute Nationaltrainer der WBC Muay Thai Germany. Die Werkzeuge kommen aus der Wissenschaft. Die Belastbarkeit aus dem echten Leben.",
      quali: "Qualifikationen",
      qualifications: [
        "M.Sc. Sportpsychologie",
        "M.Sc. Sportwissenschaften",
        "Diplom Fitnessökonom",
        "Strebt aktuell einen weiteren Master im Bereich Körperpsychologie und Körperpsychotherapie an (University of East London)",
        "Nationaltrainer der WBC Muay Thai Germany seit 2023",
        "Selbst im Kampfsport aktiv seit 1993",
        "Diverse Trainer-, Kampfsporttrainer- und Coaching-Ausbildungen",
        "Über 10 Jahre als Beamter im Hochsicherheitsgefängnis tätig (davon 2 Jahre in einer Spezialeinheit)",
        "Jahrelange Erfahrung im Leistungs- und Wettkampfsport",
        "Betreuung ambitionierter Sportler und leistungsorientierter Menschen",
      ],
      badge1: "WBC Muay Thai Germany",
      badge1sub: "Nationaltrainer",
      badge2: "M.Sc. × 2",
      badge2sub: "Psychologie · Sportwiss.",
    },
    audiences: {
      eyebrow: "Für wen",
      title: "Für Menschen mit hohem Anspruch an sich selbst.",
      subtitle:
        "Egal ob Wettkampf, Führungsetage oder unternehmerische Selbstständigkeit – wenn Leistung entscheidet, prüfen wir deine Bewerbung sorgfältig.",
      items: [
        "Leistungssportler",
        "Kampfsportler",
        "Unternehmer",
        "Führungskräfte",
        "Selbstständige",
        "Trainer",
        "Ambitionierte Privatpersonen",
        "Menschen mit Leistungsdruck",
      ],
    },
    services: {
      eyebrow: "Leistungen",
      title: "Unsere Kompetenzfelder. Ein Ziel: deine Spitzenleistung.",
      items: [
        { title: "Sportpsychologie", desc: "Wissenschaftlich fundierte mentale Betreuung." },
        { title: "Mentales Coaching", desc: "Fokus, Klarheit und mentale Robustheit." },
        { title: "Wettkampfvorbereitung", desc: "Peak-Performance auf den Punkt." },
        { title: "Stressmanagement", desc: "Ressourcenorientierter Umgang mit Belastung." },
        { title: "Selbstvertrauen entwickeln", desc: "Fundament für konstante Leistung." },
        { title: "Angstbewältigung", desc: "Wettkampf- und Leistungsangst gezielt lösen." },
        { title: "Flow-Zustände erreichen", desc: "Zustandssteuerung für Höchstleistung." },
        { title: "Zielsetzung", desc: "Klar, messbar, motivierend." },
        { title: "Motivation", desc: "Intrinsisch, nachhaltig, belastbar." },
        { title: "Resilienztraining", desc: "Widerstandskraft in Drucksituationen." },
        { title: "Rückkehr nach Verletzungen", desc: "Mentale Begleitung im Return-to-Performance." },
        { title: "High Performance Coaching", desc: "Betreuung auf Spitzensportniveau." },
        { title: "Persönlichkeitsentwicklung", desc: "Wachstum jenseits der Bestzeit." },
      ],
    },
    process: {
      eyebrow: "Ablauf",
      title: "Ein klarer Weg — von der Bewerbung bis zur Spitzenleistung.",
      steps: [
        {
          k: "01",
          t: "Bewerbung",
          d: "Du bewirbst dich mit einer kurzen Motivation. Wir prüfen jede Bewerbung persönlich und melden uns innerhalb von 48 Stunden.",
        },
        {
          k: "02",
          t: "Persönliches Auswahlgespräch",
          d: "Bei passender Ausgangslage folgt ein vertrauliches Gespräch – als Grundlage für die endgültige Aufnahme.",
        },
        {
          k: "03",
          t: "Analyse & Performance Plan",
          d: "Standortbestimmung: Leistungsprofil, Ziele, Ressourcen, Hebel — anschließend dein individueller Performance Plan.",
        },
        {
          k: "04",
          t: "Persönliche Betreuung",
          d: "Regelmäßige Sessions, konkrete Werkzeuge, Umsetzung im Alltag — persönlich, diskret, konsequent.",
        },
        {
          k: "05",
          t: "Kontinuierliche Optimierung",
          d: "Wir messen, justieren und heben deine Leistung Schritt für Schritt.",
        },
      ],
    },
    online: {
      eyebrow: "Coaching weltweit",
      title: "Ortsunabhängig. Flexibel. Auf deinem Niveau.",
      p: "Die gesamte Betreuung kann flexibel und ortsunabhängig durchgeführt werden – ob zwischen Trainingseinheiten, Business-Meetings oder Wettkampf-Reisen.",
      items: ["Zoom", "Microsoft Teams", "Telefon", "Persönliche Termine", "Individuelle Terminplanung", "Ortsunabhängig"],
    },
    premium: {
      eyebrow: "Qualität statt Masse",
      title: "Wir arbeiten mit wenigen. Dafür kompromisslos individuell.",
      p: "LionPerformance nimmt bewusst nur eine begrenzte Anzahl an Privatklienten auf. Jede Zusammenarbeit erfolgt persönlich, diskret und auf höchstem Qualitätsniveau — und ausschließlich nach Prüfung deiner Bewerbung.",
      cta: "Bewerbung starten",
    },
    testimonials: {
      eyebrow: "Stimmen",
      title: "Erfahrungen aus der Betreuung.",
      placeholder: "Aus Gründen der Diskretion nennen wir keine Namen. Alle Zitate stammen von aktiven oder ehemaligen Klienten.",
      items: [
        { q: "Die klare Struktur und wissenschaftliche Herangehensweise haben mir geholfen, meine Leistung in entscheidenden Momenten abzurufen.", n: "Kampfsportler" },
        { q: "Endlich ein Coaching, das nicht nur motiviert, sondern Methodik und System liefert.", n: "Unternehmer" },
        { q: "Meine Wettkampfvorbereitung ist heute vollkommen anders – strukturiert, fokussiert, mental stark.", n: "Leistungssportlerin" },
      ],
    },
    faq: {
      eyebrow: "Häufige Fragen",
      title: "Alles, was du vor deiner Bewerbung wissen möchtest.",
      items: [
        {
          q: "Warum ein Bewerbungsverfahren?",
          a: "Wir arbeiten mit einer bewusst kleinen Anzahl an Klienten. Nur so können wir jedem Einzelnen die persönliche Aufmerksamkeit und Tiefe geben, die echte Spitzenleistung erfordert. Die Bewerbung stellt sicher, dass Ausrichtung, Ziele und Erwartungen beidseitig passen.",
        },
        {
          q: "Wie läuft die Bewerbung ab?",
          a: "Du füllst das Bewerbungsformular unten aus — mit deiner Motivation, Zielen und Kontext. Wir prüfen jede Bewerbung persönlich und melden uns innerhalb von 48 Stunden. Bei passender Ausgangslage folgt ein vertrauliches Auswahlgespräch.",
        },
        {
          q: "Wird jede Bewerbung angenommen?",
          a: "Nein. Wir prüfen jede Bewerbung sorgfältig und arbeiten ausschließlich mit Menschen zusammen, deren Ausrichtung und Anspruch zu unserer Arbeitsweise passen. Eine Absage ist keine Wertung — sondern Ausdruck unseres Qualitätsanspruchs.",
        },
        {
          q: "Wie lange dauert eine Betreuung?",
          a: "Das hängt von Zielen und Wettkampfkalender ab. Übliche Formate reichen von 8 Wochen intensiv (z. B. Wettkampfvorbereitung) bis zu langfristiger, ganzjähriger Begleitung.",
        },
        {
          q: "Online oder vor Ort?",
          a: "Beides ist möglich. Der Großteil der Klienten wird ortsunabhängig über Zoom, Teams oder Telefon betreut. Persönliche Termine sind nach Absprache möglich.",
        },
        {
          q: "Was kostet das Coaching?",
          a: "Da jede Betreuung individuell zugeschnitten ist, wird der Investitionsrahmen erst nach Prüfung deiner Bewerbung im Auswahlgespräch besprochen — transparent, fair und passend zum Umfang.",
        },
      ],
    },
    contact: {
      eyebrow: "Bewerbung",
      title: "Bewirb dich um einen Platz.",
      subtitle:
        "Wir nehmen bewusst nur eine begrenzte Anzahl an Klienten pro Jahr auf. Jede Bewerbung wird persönlich geprüft. Innerhalb von 48 Stunden erhältst du unsere Rückmeldung.",
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail",
      phone: "Telefon (optional)",
      sport_context: "Sport / Beruflicher Kontext",
      sport_placeholder: "z. B. Kampfsport · Unternehmer · Führungskraft",
      goal: "Dein Ziel",
      goal_placeholder: "Was möchtest du in den nächsten 12 Monaten erreichen?",
      timeframe: "Gewünschter Startzeitpunkt",
      timeframe_placeholder: "z. B. sofort · innerhalb 4 Wochen · flexibel",
      motivation: "Warum möchtest du mit LionPerformance arbeiten?",
      motivation_placeholder:
        "Beschreibe kurz deine aktuelle Situation, was dich antreibt und warum du eine Zusammenarbeit anstrebst. Je klarer, desto besser können wir deine Bewerbung einordnen.",
      submit: "Bewerbung einreichen",
      sending: "Wird übermittelt...",
      success:
        "Deine Bewerbung ist eingegangen. Wir prüfen sie persönlich und melden uns innerhalb von 48 Stunden.",
      error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      privacy: "Deine Angaben werden vertraulich behandelt und nicht weitergegeben.",
      criteria: "Aufnahmekriterien",
      criteriaItems: [
        "Klarer Anspruch an sich selbst",
        "Bereitschaft, konsequent umzusetzen",
        "Übereinstimmung mit unserer Arbeitsweise",
      ],
      capacity: "Aktuelle Kapazität: sehr begrenzt",
      response: "Rückmeldung innerhalb von 48 h",
      note: "Eine Zusage ist nicht garantiert. Wir prüfen jede Bewerbung persönlich und entscheiden auf Basis von Übereinstimmung, Ausrichtung und Kapazität.",
      consent_prefix: "Ich habe die",
      consent_terms: "AGB",
      consent_and: "und die",
      consent_privacy: "Datenschutzbestimmungen",
      consent_suffix: "gelesen und stimme diesen zu.",
      consent_required: "Bitte bestätige die AGB und Datenschutzbestimmungen, um deine Bewerbung abzusenden.",
    },
    footer: {
      tagline: "Wissenschaftlich fundierte Sportpsychologie. High Performance Coaching auf Spitzensportniveau — nur nach Bewerbung.",
      nav: "Navigation",
      legal: "Rechtliches",
      social: "Kontakt & Social",
      privacy: "Datenschutz",
      imprint: "Impressum",
      contact: "Bewerbung",
      copyright: "Alle Rechte vorbehalten.",
      placeholder: "— Kontaktdaten & Social Media folgen —",
    },
    lang: { de: "DE", en: "EN" },
  },
  en: {
    nav: {
      why: "Why",
      coach: "Coach",
      services: "Services",
      process: "Process",
      faq: "FAQ",
      contact: "Apply",
      cta: "Apply now",
    },
    hero: {
      eyebrow: "Sports Psychology · High Performance Coaching",
      title1: "Talent wins training.",
      title2: "",
      title3: "The mind wins competitions.",
      subtitle:
        "A systematic process for body, mind and psyche — until your performance matches your ambition.",
      cta1: "Apply for coaching now",
      cta2: "Learn more",
      scroll: "Scroll",
      trustbar: [
        "Combat sports since 1993",
        "National coach WBC Muay Thai",
        "M.Sc. Sports Psychology & Science",
        "Admission by application only",
      ],
    },
    marquee: [
      "Science-based",
      "Private clients only",
      "Coached worldwide",
      "Maximum discretion",
      "Measurable progress",
      "By application only",
    ],
    trust: {
      eyebrow: "Why LionPerformance",
      title: "Coaching that produces results.",
      subtitle:
        "We work like you: uncompromising, science-based and maximally individual. Admission is by application only.",
      items: [
        { title: "Science-based", desc: "Methods from sports science, sports psychology and modern performance diagnostics." },
        { title: "Individual coaching", desc: "No off-the-shelf programs — every collaboration is tailor-made." },
        { title: "Maximum discretion", desc: "All content, conversations and data are treated confidentially." },
        { title: "Flexible online coaching", desc: "Coached worldwide — via Zoom, Teams, phone or in person." },
        { title: "Measurable progress", desc: "Clear metrics, documented progress, transparent impact." },
        { title: "By application only", desc: "We deliberately work with a very limited number of clients." },
      ],
    },
    coach: {
      eyebrow: "About the Coach",
      title: "Elite-sport experience. Science that works.",
      p1: "LionPerformance is led by an experienced national coach of WBC Muay Thai Germany.",
      p2: "The coaching combines hands-on experience from elite sports with science-based sports psychology and modern performance diagnostics.",
      story:
        "Combat sports since 1993. Over 10 years under maximum pressure as an officer in a maximum-security prison — 2 of which in a special unit. Today: national coach of WBC Muay Thai Germany. The tools come from science. The resilience comes from real life.",
      quali: "Qualifications",
      qualifications: [
        "M.Sc. Sports Psychology",
        "M.Sc. Sports Science",
        "Diploma Fitness Economics",
        "Currently pursuing an additional M.Sc. in Body Psychology and Body Psychotherapy (University of East London)",
        "National coach of WBC Muay Thai Germany since 2023",
        "Active combat athlete since 1993",
        "Various trainer, combat sports coach and coaching certifications",
        "Over 10 years as an officer in a maximum-security prison (2 of which in a special unit)",
        "Years of experience in competitive and elite sports",
        "Coaching of ambitious athletes and performance-driven individuals",
      ],
      badge1: "WBC Muay Thai Germany",
      badge1sub: "National Coach",
      badge2: "M.Sc. × 2",
      badge2sub: "Psychology · Sports Sci",
    },
    audiences: {
      eyebrow: "Who it's for",
      title: "For people with high standards.",
      subtitle:
        "Whether competition, C-level or entrepreneurship — when performance decides, we carefully review your application.",
      items: [
        "Elite athletes",
        "Combat athletes",
        "Entrepreneurs",
        "Executives",
        "Self-employed",
        "Coaches",
        "Ambitious individuals",
        "High-pressure performers",
      ],
    },
    services: {
      eyebrow: "Services",
      title: "Our fields of expertise. One goal: your peak performance.",
      items: [
        { title: "Sports Psychology", desc: "Science-based mental coaching." },
        { title: "Mental Coaching", desc: "Focus, clarity and mental robustness." },
        { title: "Competition Prep", desc: "Peak performance on demand." },
        { title: "Stress Management", desc: "Resource-oriented handling of pressure." },
        { title: "Self-Confidence", desc: "The foundation for consistent performance." },
        { title: "Anxiety Management", desc: "Solving competition and performance anxiety." },
        { title: "Flow States", desc: "State management for peak output." },
        { title: "Goal Setting", desc: "Clear, measurable, motivating." },
        { title: "Motivation", desc: "Intrinsic, sustainable, resilient." },
        { title: "Resilience Training", desc: "Strength under pressure." },
        { title: "Return after Injury", desc: "Mental guidance in the return-to-performance process." },
        { title: "High Performance Coaching", desc: "Coaching at elite level." },
        { title: "Personal Development", desc: "Growth beyond the personal best." },
      ],
    },
    process: {
      eyebrow: "Process",
      title: "A clear path — from application to peak performance.",
      steps: [
        { k: "01", t: "Application", d: "You apply with a short motivation. We review every application personally and respond within 48 hours." },
        { k: "02", t: "Selection call", d: "If there is a fit, a confidential call follows — the basis for final admission." },
        { k: "03", t: "Analysis & Performance Plan", d: "Baseline: performance profile, goals, resources, levers — then your tailored roadmap." },
        { k: "04", t: "Personal coaching", d: "Regular sessions, concrete tools, real-world execution — personal, discreet, consistent." },
        { k: "05", t: "Continuous optimization", d: "Measure, adjust, elevate — step by step." },
      ],
    },
    online: {
      eyebrow: "Coaching worldwide",
      title: "Location-independent. Flexible. On your level.",
      p: "The entire coaching can be conducted flexibly and location-independent — whether between training sessions, business meetings or competition travel.",
      items: ["Zoom", "Microsoft Teams", "Phone", "In-person sessions", "Individual scheduling", "Location-independent"],
    },
    premium: {
      eyebrow: "Quality over quantity",
      title: "We work with few. Uncompromisingly individual.",
      p: "LionPerformance deliberately admits only a limited number of private clients. Every collaboration is personal, discreet and at the highest level — and only after review of your application.",
      cta: "Start application",
    },
    testimonials: {
      eyebrow: "Voices",
      title: "Experiences from coaching.",
      placeholder: "For reasons of discretion we don't name clients. All quotes are from active or former clients.",
      items: [
        { q: "The clear structure and science-based approach helped me deliver in the decisive moments.", n: "Combat athlete" },
        { q: "Finally coaching that doesn't just motivate but delivers real methodology and system.", n: "Entrepreneur" },
        { q: "My competition prep today is completely different — structured, focused, mentally strong.", n: "Elite athlete" },
      ],
    },
    faq: {
      eyebrow: "Frequently asked",
      title: "Everything you'd like to know before applying.",
      items: [
        { q: "Why an application process?", a: "We work with a deliberately small number of clients. Only that way can we give each individual the personal attention and depth that real peak performance requires. The application ensures alignment, goals and expectations fit on both sides." },
        { q: "How does the application work?", a: "You fill in the application form below — with your motivation, goals and context. We review every application personally and respond within 48 hours. If there's a fit, a confidential selection call follows." },
        { q: "Is every application accepted?", a: "No. We carefully review every application and only work with people whose orientation and standards match our approach. A decline is not a judgment — it's an expression of our quality standards." },
        { q: "How long does coaching last?", a: "Depends on your goals and competition calendar. Common formats range from 8-week intensives (e.g. competition prep) to year-round mentoring." },
        { q: "Online or in person?", a: "Both. Most clients are coached location-independently via Zoom, Teams or phone. In-person sessions on request." },
        { q: "What does it cost?", a: "Since every engagement is individually tailored, the investment is discussed only after review of your application in the selection call — transparent, fair and matched to scope." },
      ],
    },
    contact: {
      eyebrow: "Application",
      title: "Apply for a spot.",
      subtitle:
        "We deliberately take on only a limited number of clients per year. Every application is reviewed personally. You'll hear back from us within 48 hours.",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone (optional)",
      sport_context: "Sport / Professional context",
      sport_placeholder: "e.g. Combat sports · Entrepreneur · Executive",
      goal: "Your goal",
      goal_placeholder: "What do you want to achieve in the next 12 months?",
      timeframe: "Preferred start",
      timeframe_placeholder: "e.g. immediately · within 4 weeks · flexible",
      motivation: "Why do you want to work with LionPerformance?",
      motivation_placeholder:
        "Briefly describe your current situation, what drives you and why you're seeking this collaboration. The clearer, the better we can evaluate your application.",
      submit: "Submit application",
      sending: "Submitting...",
      success:
        "Your application has been received. We're reviewing it personally and will get back to you within 48 hours.",
      error: "Something went wrong. Please try again.",
      privacy: "Your information is treated confidentially and never shared.",
      criteria: "Admission criteria",
      criteriaItems: [
        "Clear personal standards",
        "Willingness to execute consistently",
        "Fit with our way of working",
      ],
      capacity: "Current capacity: very limited",
      response: "Response within 48 hours",
      note: "Admission is not guaranteed. We review every application personally and decide based on fit, orientation and capacity.",
      consent_prefix: "I have read the",
      consent_terms: "Terms",
      consent_and: "and the",
      consent_privacy: "Privacy Policy",
      consent_suffix: "and agree to them.",
      consent_required: "Please accept the Terms and Privacy Policy to submit your application.",
    },
    footer: {
      tagline: "Science-based sports psychology. High performance coaching at elite level — by application only.",
      nav: "Navigation",
      legal: "Legal",
      social: "Contact & Social",
      privacy: "Privacy",
      imprint: "Imprint",
      contact: "Apply",
      copyright: "All rights reserved.",
      placeholder: "— Contact details & social media coming soon —",
    },
    lang: { de: "DE", en: "EN" },
  },
};
